<div class="relative">
  <tui-loader [overlay]="true" [showLoader]="isLoading">
    <div class="container">
      <div class="flex gap-3 border-b border-b-accent pb-2">
        <button style="cursor: pointer" class="p-2" (click)="navigateToView()">
          <tui-svg
            src="tuiIconArrowLeftCircleLarge"
            style="color: black"
            class="hover:scale-110 transition-all duration-100"
          ></tui-svg>
        </button>
        <p
          class="flex items-center text-[#000000] text-[1.5rem] font-bold"
          *ngIf="status !== 'edit'"
        >
          Add New User
        </p>
        <p
          class="flex items-center text-[#000000] text-[1.5rem] font-bold"
          *ngIf="status === 'edit' && !isFirstLogin"
        >
          Edit User
        </p>
        <p
          class="flex items-center text-[#000000] text-[1.5rem] font-bold"
          *ngIf="status === 'edit' && isFirstLogin"
        >
          Update Password
        </p>
        <!-- <p class="flex items-center text-accent text-[18px]" *ngIf="status === 'edit' && (isFirstLogin || isPasswordReset)">Update Password</p> -->
      </div>
      <div
        class="flex items-center justify-center xl:justify-normal mt-5 2xl:mt-10 lg:ml-10"
      >
        <div class="w-full sm:w-[400px]">
          <form class="" [formGroup]="userForm" *ngIf="!isFirstLogin">
            <!-- <form [formGroup]="userForm" *ngIf="!isFirstLogin && !isPasswordReset"> -->
            <div>
              <label for="firstname" class="text-black">Enter First Name</label>
              <tui-input
                formControlName="firstname"
                tuiTextfieldSize="l"
                [tuiTextfieldCleaner]="true"
                [tuiTextfieldLabelOutside]="true"
                [style.text-align]="'left'"
                class="tui-space_top-1"
              >
                First Name
                <input autocomplete="fname" tuiTextfield type="text" />
              </tui-input>
              <tui-error
                formControlName="firstname"
                [error]="[] | tuiFieldError | async"
              ></tui-error>
            </div>

            <div class="mt-4">
              <label for="lastname" class="text-black">Enter Last Name</label>
              <tui-input
                formControlName="lastname"
                tuiTextfieldSize="l"
                [tuiTextfieldCleaner]="true"
                [tuiTextfieldLabelOutside]="true"
                [style.text-align]="'left'"
                class="tui-space_top-1"
              >
                Last Name
                <input autocomplete="lname" tuiTextfield type="text" />
              </tui-input>
              <tui-error
                formControlName="lastname"
                [error]="[] | tuiFieldError | async"
              ></tui-error>
            </div>

            <div class="mt-4">
              <label for="email" class="text-black">Enter Email Address</label>
              <tui-input
                formControlName="email"
                tuiTextfieldSize="l"
                [tuiTextfieldCleaner]="true"
                [tuiTextfieldLabelOutside]="true"
                [style.text-align]="'left'"
                class="tui-space_top-1"
              >
                Email Address
                <input autocomplete="email" tuiTextfield type="email" />
              </tui-input>
              <tui-error
                formControlName="email"
                [error]="[] | tuiFieldError | async"
              ></tui-error>
            </div>

            <div class="mt-4">
              <label for="mobileNo" class="text-black"
                >Enter Mobile Number</label
              >
              <tui-input
                formControlName="mobileNo"
                tuiTextfieldSize="l"
                [tuiTextfieldCleaner]="true"
                [tuiTextfieldLabelOutside]="true"
                [style.text-align]="'left'"
                class="tui-space_top-1"
              >
                Mobile Number
                <input autocomplete="phone" tuiTextfield type="tel" />
              </tui-input>
              <tui-error
                formControlName="mobileNo"
                [error]="[] | tuiFieldError | async"
              ></tui-error>
            </div>

            <div class="mt-4">
              <label for="role" class="text-black">Select User Role</label>
              <tui-select
                formControlName="role"
                tuiTextfieldSize="l"
                [tuiTextfieldLabelOutside]="true"
                [style.text-align]="'left'"
                class="tui-space_top-1"
              >
                User Role
                <input autocomplete="role" tuiTextfield type="text" />
                <tui-data-list-wrapper
                  *tuiDataList
                  [items]="roleitems"
                ></tui-data-list-wrapper>
              </tui-select>
            </div>

            <div class="mt-4">
              <label for="isActive" class="text-black"
                >Select User Status</label
              >
              <tui-select
                formControlName="isActive"
                tuiTextfieldSize="l"
                [tuiTextfieldLabelOutside]="true"
                [style.text-align]="'left'"
                class="tui-space_top-1"
              >
                User Status
                <input autocomplete="status" tuiTextfield type="text" />
                <tui-data-list-wrapper
                  *tuiDataList
                  [items]="statusitems"
                ></tui-data-list-wrapper>
              </tui-select>
            </div>

            <div class="flex gap-3 mt-5">
              <div class="w-full h-full">
                <button
                  (click)="cancel()"
                  tuiButton
                  appearance="secondary"
                  type="button"
                  class="w-full h-full text-[#bb0021] hover:bg-[#faf0f2] hover:text-[#bb0021]"
                >
                  Cancel
                </button>
              </div>

              <div class="w-full">
                <button
                  tuiButton
                  appearance="primary"
                  type="button"
                  class="w-full"
                  *ngIf="status === 'add'"
                  (click)="onSubmit()"
                  [showLoader]="isLoading"
                >
                  <span class="text-white">Add User</span>
                </button>

                <button
                  tuiButton
                  type="button"
                  class="w-full"
                  *ngIf="status === 'edit'"
                  (click)="onUpdate()"
                  [showLoader]="isLoading"
                >
                  <span class="text-white">Update User</span>
                </button>
              </div>
            </div>
          </form>

          <form class="" [formGroup]="passwordForm" *ngIf="isFirstLogin">
            <!-- <form [formGroup]="passwordForm" *ngIf="isFirstLogin || isPasswordReset"> -->
            <div>
              <label for="password" class="text-[#FFFFFFB8]">Password</label>
              <tui-input-password
                formControlName="password"
                tuiTextfieldSize="l"
                [tuiTextfieldCleaner]="true"
                [tuiTextfieldLabelOutside]="true"
                [style.text-align]="'left'"
                class="tui-space_top-1"
              >
                Password
                <input autocomplete="fname" tuiTextfield type="text" />
              </tui-input-password>
            </div>

            <div class="mt-4">
              <label for="passwordConfirm" class="text-[#FFFFFFB8]"
                >Confirm Password</label
              >
              <tui-input-password
                formControlName="passwordConfirm"
                tuiTextfieldSize="l"
                [tuiTextfieldCleaner]="true"
                [tuiTextfieldLabelOutside]="true"
                [style.text-align]="'left'"
                class="tui-space_top-1"
              >
                Re-Password
                <input autocomplete="lname" tuiTextfield type="text" />
              </tui-input-password>
            </div>

            <div class="flex gap-3 mt-5">
              <div class="w-full h-full">
                <button
                  (click)="cancel()"
                  tuiButton
                  appearance="secondary"
                  type="button"
                  class="w-full h-full text-[#bb0021] hover:bg-[#faf0f2] hover:text-[#bb0021]"
                >
                  Cancel
                </button>
              </div>
              <div class="w-full">
                <button
                  tuiButton
                  type="button"
                  class="w-full"
                  *ngIf="status === 'edit'"
                  (click)="onChangePassword()"
                  [disabled]="passwordForm.invalid"
                >
                  Update
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </tui-loader>
</div>
